AuthRoute = require 'mixins/authenticated-route'

###
# Меню со всеми блюдами и категориями
###
App.CategoriesRoute = Em.Route.extend AuthRoute,
  beforeModelAuth: (transition) ->
    Em.RSVP.hash(
      allRestaurants:  @store.find('restaurant', {})
    ).then (props) =>
      @controllerFor('categories').setProperties(props)

  model: ->
    organization = @controllerFor('categories').get('organization')
    @store.find('draft_category')

  setupController: (controller, model) ->
    @_super controller, model

  actions:
    didTransition: ->
      @get('controller').installMenuRevelanceHandler()
